export default {
	path: '/warn-work',
	redirect: '/warn-work',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'warnWorkHome',
			component: () => import('@/views/mng/WarnWork'),
		},
	],
};
